/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Recipient_TutorInputs */

const en_recipient_tutor = /** @type {(inputs: Recipient_TutorInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`tutor`)
};

const he_recipient_tutor = /** @type {(inputs: Recipient_TutorInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`מורה`)
};

/**
* | output |
* | --- |
* | "tutor" |
*
* @param {Recipient_TutorInputs} inputs
* @param {{ locale?: "en" | "he" }} options
* @returns {LocalizedString}
*/
export const recipient_tutor = /** @type {((inputs?: Recipient_TutorInputs, options?: { locale?: "en" | "he" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Recipient_TutorInputs, { locale?: "en" | "he" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_recipient_tutor(inputs)
	return he_recipient_tutor(inputs)
});